import { useAppSelector } from 'app/state'

export const useMapFilters = () => {
  const currentSearch = useAppSelector((state) => state.maps.myMapsFilters.search)
  const currentOwnerFilter = useAppSelector((state) => state.maps.myMapsFilters.filter?.permissions)
  const currentTagsFilter = useAppSelector((state) => state.maps.myMapsFilters.filter?.tags)

  const hasActiveFilters = Boolean(
    currentSearch || currentOwnerFilter || (currentTagsFilter && currentTagsFilter.length > 0)
  )

  return {
    hasActiveFilters,
    currentSearch,
    currentOwnerFilter,
    currentTagsFilter
  }
}
